var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.item }
    },
    [
      _c(
        "div",
        { staticClass: "simple-form" },
        _vm._l(_vm.item.tradeRuleList, function(tradeRule, index) {
          return _vm.item.tradeRuleList.length > 0
            ? _c(
                "div",
                {
                  staticClass: "form-group center",
                  staticStyle: { "border-bottom": "1px dotted #EEE" }
                },
                [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v(_vm._s(tradeRule.name))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      tradeRule.type == _vm.singleRuleType.value
                        ? _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.operate == "chakan" },
                              model: {
                                value: tradeRule.optionValue,
                                callback: function($$v) {
                                  _vm.$set(tradeRule, "optionValue", $$v)
                                },
                                expression: "tradeRule.optionValue"
                              }
                            },
                            _vm._l(tradeRule.tradeRuleOptionList, function(
                              tradeRuleOption,
                              tradeRuleOptionIndex
                            ) {
                              return _c(
                                "el-radio",
                                { attrs: { label: tradeRuleOption.id } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(tradeRuleOption.name))
                                  ]),
                                  _vm._v(" "),
                                  tradeRuleOption.extFlag == 1
                                    ? _c(
                                        "div",
                                        { staticClass: "inline-block" },
                                        [
                                          tradeRuleOption.code == "Unified"
                                            ? _c(
                                                "div",
                                                [
                                                  tradeRule.optionValue ==
                                                  tradeRuleOption.id
                                                    ? _c(
                                                        "el-form-item",
                                                        {
                                                          key:
                                                            tradeRuleOption.id,
                                                          attrs: {
                                                            prop:
                                                              "tradeRuleList." +
                                                              index +
                                                              ".tradeRuleOptionList." +
                                                              tradeRuleOptionIndex +
                                                              ".extValue",
                                                            rules: {
                                                              validator:
                                                                _vm.validateNum,
                                                              trigger: "blur"
                                                            }
                                                          }
                                                        },
                                                        [
                                                          tradeRuleOption.extPattern !=
                                                          null
                                                            ? _c(
                                                                "swb-pattern-input",
                                                                {
                                                                  ref:
                                                                    tradeRule.code,
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    pattern:
                                                                      tradeRuleOption.extPattern,
                                                                    initValue:
                                                                      tradeRuleOption.extValue,
                                                                    inputType:
                                                                      "Num",
                                                                    valueType:
                                                                      "Integer",
                                                                    readOnly:
                                                                      tradeRule.optionValue !=
                                                                        tradeRuleOption.id ||
                                                                      _vm.operate ==
                                                                        "chakan"
                                                                  }
                                                                }
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  tradeRuleOption.extPattern !=
                                                    null &&
                                                  tradeRule.optionValue !=
                                                    tradeRuleOption.id
                                                    ? _c("swb-pattern-input", {
                                                        ref: tradeRule.code,
                                                        refInFor: true,
                                                        attrs: {
                                                          pattern:
                                                            tradeRuleOption.extPattern,
                                                          initValue:
                                                            tradeRuleOption.extValue,
                                                          inputType: "Num",
                                                          valueType: "Integer",
                                                          readOnly:
                                                            tradeRule.optionValue !=
                                                              tradeRuleOption.id ||
                                                            _vm.operate ==
                                                              "chakan"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          tradeRuleOption.code == "Charge" ||
                                          tradeRuleOption.code == "Plain" ||
                                          tradeRuleOption.code == "Special"
                                            ? _c(
                                                "div",
                                                [
                                                  tradeRuleOption.extPattern !=
                                                  null
                                                    ? _c("swb-pattern-input", {
                                                        ref: tradeRule.code,
                                                        refInFor: true,
                                                        attrs: {
                                                          pattern:
                                                            tradeRuleOption.extPattern,
                                                          initValue:
                                                            tradeRuleOption.extValue,
                                                          inputType: "Text",
                                                          valueType: "String",
                                                          readOnly:
                                                            tradeRule.optionValue !=
                                                              tradeRuleOption.id ||
                                                            _vm.operate ==
                                                              "chakan"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: {
                                        disabled:
                                          tradeRule.optionValue !=
                                            tradeRuleOption.id ||
                                          _vm.operate == "chakan"
                                      },
                                      model: {
                                        value: tradeRuleOption.optionValue,
                                        callback: function($$v) {
                                          _vm.$set(
                                            tradeRuleOption,
                                            "optionValue",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "tradeRuleOption.optionValue"
                                      }
                                    },
                                    _vm._l(
                                      tradeRuleOption.tradeRuleSubOptionList,
                                      function(tradeRuleSubOption) {
                                        return _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: tradeRuleSubOption.id
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(tradeRuleSubOption.name)
                                              )
                                            ])
                                          ]
                                        )
                                      }
                                    )
                                  )
                                ],
                                1
                              )
                            })
                          )
                        : tradeRule.type == _vm.multiRuleType.value
                        ? _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: tradeRule.optionValueList,
                                callback: function($$v) {
                                  _vm.$set(tradeRule, "optionValueList", $$v)
                                },
                                expression: "tradeRule.optionValueList"
                              }
                            },
                            _vm._l(tradeRule.tradeRuleOptionList, function(
                              tradeRuleOption
                            ) {
                              return _c(
                                "el-checkbox",
                                {
                                  staticClass: "display-block mb5",
                                  attrs: {
                                    disabled: _vm.operate == "chakan",
                                    label: tradeRuleOption.id
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.changeCheck(tradeRuleOption)
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(tradeRuleOption.name))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "ml20",
                                      attrs: {
                                        disabled:
                                          !tradeRuleOption.checked ||
                                          _vm.operate == "chakan"
                                      },
                                      model: {
                                        value: tradeRuleOption.optionValue,
                                        callback: function($$v) {
                                          _vm.$set(
                                            tradeRuleOption,
                                            "optionValue",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "tradeRuleOption.optionValue"
                                      }
                                    },
                                    _vm._l(
                                      tradeRuleOption.tradeRuleSubOptionList,
                                      function(tradeRuleSubOption) {
                                        return _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: tradeRuleSubOption.id
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(tradeRuleSubOption.name)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            tradeRuleSubOption.extFlag == 1 &&
                                            tradeRuleSubOption.code ==
                                              "FixedOneAddress"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "inline-block ml15"
                                                  },
                                                  [
                                                    tradeRuleSubOption.extPattern !=
                                                    null
                                                      ? _c(
                                                          "swb-pattern-input",
                                                          {
                                                            ref: tradeRule.code,
                                                            refInFor: true,
                                                            attrs: {
                                                              pattern:
                                                                tradeRuleSubOption.extPattern,
                                                              initValue:
                                                                tradeRuleOption.extValue,
                                                              inputType: "Text",
                                                              valueType:
                                                                "String",
                                                              readOnly:
                                                                !tradeRuleOption.checked ||
                                                                tradeRuleOption.optionValue !=
                                                                  tradeRuleSubOption.id ||
                                                                _vm.operate ==
                                                                  "chakan"
                                                            }
                                                          }
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      }
                                    )
                                  )
                                ],
                                1
                              )
                            })
                          )
                        : tradeRule.type == _vm.textType.value
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  disabled: _vm.operate == "chakan",
                                  type: "text"
                                },
                                model: {
                                  value: tradeRule.context,
                                  callback: function($$v) {
                                    _vm.$set(tradeRule, "context", $$v)
                                  },
                                  expression: "tradeRule.context"
                                }
                              })
                            ],
                            1
                          )
                        : tradeRule.type == _vm.numType.value
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  disabled: _vm.operate == "chakan",
                                  type: "number"
                                },
                                model: {
                                  value: tradeRule.context,
                                  callback: function($$v) {
                                    _vm.$set(tradeRule, "context", $$v)
                                  },
                                  expression: "tradeRule.context"
                                }
                              })
                            ],
                            1
                          )
                        : tradeRule.type == _vm.mlTextType.value
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  disabled: _vm.operate == "chakan",
                                  type: "textarea",
                                  autosize: { minRows: 3, maxRows: 5 }
                                },
                                model: {
                                  value: tradeRule.context,
                                  callback: function($$v) {
                                    _vm.$set(tradeRule, "context", $$v)
                                  },
                                  expression: "tradeRule.context"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "callBid" || _vm.type == "priceInqry"
                        ? _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _vm.type == "callBid"
                                ? _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: _vm.operate == "chakan"
                                      },
                                      model: {
                                        value: tradeRule.revisable,
                                        callback: function($$v) {
                                          _vm.$set(tradeRule, "revisable", $$v)
                                        },
                                        expression: "tradeRule.revisable"
                                      }
                                    },
                                    [_vm._v("投标方可修改")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.type == "priceInqry"
                                ? _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: _vm.operate == "chakan"
                                      },
                                      model: {
                                        value: tradeRule.revisable,
                                        callback: function($$v) {
                                          _vm.$set(tradeRule, "revisable", $$v)
                                        },
                                        expression: "tradeRule.revisable"
                                      }
                                    },
                                    [_c("span", [_vm._v("报价方可修改")])]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        })
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-add10894", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-add10894","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tradeRule/CreateTradeRule.vue
// module id = 2743
// module chunks = 0